import { MappedClass, MappedProperty } from '@h5s/util-object';

@MappedClass()
export class ZPrinterInt32Applicable {
  @MappedProperty()
  is_applicable: boolean;

  @MappedProperty()
  read_only: boolean;

  @MappedProperty()
  value: number;
}
